<template>
  <div class="flex justify-center bg-white h-screen overflow-y-scroll">
    <div class="c19">
      <MainLogo class="flex justify-center items-center my-n-5xl"/>
      <p class="c1"><span class="c12">DIBBS FEE SCHEDULE</span></p>
      <p class="c1 c7"><span class="c12"></span></p>
      <p class="c6"><span class="c15">Your activities and transactions on the Dibbs Platform will incur fees from Dibbs in
          accordance with this fee schedule (the &ldquo;</span><span class="c16">Fee Schedule</span><span
          class="c0">&rdquo;). This Fee Schedule may be amended from time to time in Dibbs&rsquo; sole discretion. </span>
      </p>
      <p class="c6 c7"><span class="c0"></span></p>
      <p class="c6"><span class="c15">Capitalized terms not otherwise defined in this Fee Schedule have the meanings given
          to them in our </span><router-link class="c15 c70" to="/user-agreement" target="_blank" rel="noopener noreferrer">User Agreement</router-link><span class="c0">.</span></p>
      <p class="c6 c7"><span class="c0"></span></p>
      <p class="c6"><span class="c15">In addition to amounts set forth in this Fee Schedule, your activities on the Dibbs
          Platform may incur third-party fees, including from your bank or credit card provider, and/or Prime Trust, LLC
          in
          connection with your PT Account (collectively, &ldquo;</span><span class="c16">Third-Party Fees</span><span
          class="c0">&rdquo;). You agree and understand that Third-Party Fees are not included in this Fee Schedule, and
          that you are solely responsible for payment of any Third-Party Fees. </span></p>
      <p class="c6 c7"><span class="c12"></span></p><a id="t.664822e907a9d69edb3120818f6a1be99c0b6380"></a><a
        id="t.0"></a>
      <table class="c18">
        <tbody>
          <tr class="c5">
            <td class="c11" colspan="3" rowspan="1">
              <p class="c4"><span class="c12">Trading Fees</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">Purchase and &nbsp;Sell Orders (market or limit)</span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">2.9% of Order Value</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">Drops</span></p>
              <p class="c4 c7"><span class="c0"></span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">5% of Order Value</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c11" colspan="3" rowspan="1">
              <p class="c4"><span class="c12">Cash Deposit Fees</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">Wire</span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">$0 - $45</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">ACH</span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">None</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">Debit Card</span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">0% - 4.5%</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">Credit Card</span></p>
              <p class="c4 c7"><span class="c0"></span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">0% - 4.5%</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c11" colspan="3" rowspan="1">
              <p class="c4"><span class="c12">Cash Withdrawal Fees</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">Wire</span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">$5 - $30</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">ACH</span></p>
              <p class="c4 c7"><span class="c0"></span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">$2 - $20</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c12">Consigned Card Withdrawal Fees*</span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c4 c7"><span class="c12"></span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">Withdrawal of Consigned Card**</span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">2.9% of Consigned Card&rsquo;s Market Price</span></p>
            </td>
          </tr>
          <tr class="c5">
            <td class="c14" colspan="1" rowspan="1">
              <p class="c4"><span class="c0">Withdrawal of Card Token</span></p>
            </td>
            <td class="c9" colspan="2" rowspan="1">
              <p class="c3"><span class="c0">5% of Consigned Card&rsquo;s Market Price</span></p>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="c6 c7"><span class="c0"></span></p>
      <p class="c6"><span class="c0">*Consigned Card Withdrawals may also give rise to fees associated with On-Chain
          Transactions. &nbsp;The amount of these fees will fluctuate based on network conditions and other factors beyond
          our control. &nbsp;These fees will be estimated by Dibbs at the time you initiate an On-Chain Transaction and
          disclosed to you in accordance with the <router-link class="c4 c15 c70" to="/user-agreement" target="_blank" rel="noopener noreferrer">User Agreement</router-link>.</span></p>
      <p class="c6 c7"><span class="c0"></span></p>
      <p class="c6"><span class="c0">** The Custodian may charge processing or other fees in connection with your
          withdrawal
          of a Consigned Card - such fees are not included in this Fee Schedule.</span></p>
      <p class="c6 c7"><span class="c0"></span></p>
      <p class="c6 c7"><span class="c0"></span></p>
      <p class="c6 c7"><span class="c0"></span></p>
    </div>
  </div>
</template>

<script>
import MainLogo from '@/stories/misc/MainLogo.vue';

export default {
  name: 'FeeSchedule',
  components: {
    MainLogo,
  },
  async mounted() {
    await this.$store.dispatch('events/track', {
      event: 'TERMS_AND_CONDITIONS_VIEWED',
      variables: {
        term: 'Fee Schedule',
      },
    });
  },
};
</script>

<style scoped>
ol{margin:0;padding:0}table td,table th{padding:0}.c14{border-right-style:solid;padding:5pt 5pt 5pt 5pt;border-bottom-color:#ffffff;border-top-width:1pt;border-right-width:1pt;border-left-color:#ffffff;vertical-align:top;border-right-color:#ffffff;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:186.8pt;border-top-color:#ffffff;border-bottom-style:solid}.c9{border-right-style:solid;padding:5pt 5pt 5pt 5pt;border-bottom-color:#ffffff;border-top-width:1pt;border-right-width:1pt;border-left-color:#ffffff;vertical-align:top;border-right-color:#ffffff;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:130.5pt;border-top-color:#ffffff;border-bottom-style:solid}.c11{border-right-style:solid;padding:5pt 5pt 5pt 5pt;border-bottom-color:#ffffff;border-top-width:1pt;border-right-width:1pt;border-left-color:#ffffff;vertical-align:top;border-right-color:#ffffff;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:317.2pt;border-top-color:#ffffff;border-bottom-style:solid}.c13{border-right-style:solid;padding:5pt 5pt 5pt 5pt;border-bottom-color:#ffffff;border-top-width:1pt;border-right-width:1pt;border-left-color:#ffffff;vertical-align:top;border-right-color:#ffffff;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:125.2pt;border-top-color:#ffffff;border-bottom-style:solid}.c10{border-right-style:solid;padding:5pt 5pt 5pt 5pt;border-bottom-color:#ffffff;border-top-width:1pt;border-right-width:1pt;border-left-color:#ffffff;vertical-align:top;border-right-color:#ffffff;border-left-width:1pt;border-top-style:solid;border-left-style:solid;border-bottom-width:1pt;width:5.2pt;border-top-color:#ffffff;border-bottom-style:solid}.c2{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Arial";font-style:normal}.c0{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11.5pt;font-family:"Times New Roman";font-style:normal}.c12{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:11.5pt;font-family:"Times New Roman";font-style:normal}.c6{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c1{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:center}.c17{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:right}.c18{margin-left:auto;border-spacing:0;border-collapse:collapse;margin-right:auto}.c3{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-align:right}.c4{padding-top:0pt;padding-bottom:0pt;line-height:1.0;text-align:left}.c19{background-color:#ffffff;max-width:468pt;padding:15pt}.c16{font-size:11.5pt;font-family:"Times New Roman";font-weight:700}.c15{font-size:11.5pt;font-family:"Times New Roman";font-weight:400}.c8{border:1px solid black;margin:5px}.c5{height:21pt}.c7{height:11pt}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Arial"}p{margin:0;color:#000000;font-size:11pt;font-family:"Arial"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}.c70{color:#1155cc;text-decoration:underline}
/* Scrollbar style */
::-webkit-scrollbar {
  width: unset;
}
::-webkit-scrollbar-track {
  background: #fff;
}
</style>
